import { useNuxtData } from '#imports'
import { computed } from 'vue'

import { merchantsAPI } from '@backmarket/http-api'
import type { GetShippingMethodsMetadata } from '@backmarket/http-api/src/api-specs-seller-backoffice/merchants/shipping-methods.types'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { CATEGORY_TYPES } from '../ShippingLegacy.constants'
import translations from '../ShippingLegacy.translations'

export function useMetaData() {
  const { data } = useHttpFetch(merchantsAPI.getShippingMethodsMetadata, {
    getCachedData: (key) =>
      useNuxtData<GetShippingMethodsMetadata>(key).data.value || undefined,
  })
  const i18n = useI18n()

  const carrierOptions = computed(
    () =>
      data.value?.carriers.map(({ id, name, backship }) => ({
        label: name,
        value: id.toString(),
        meta: { backship },
      })) || [],
  )

  const categoryOptions = computed(() =>
    [
      {
        label: i18n(translations.allCategories),
        value: CATEGORY_TYPES.GLOBAL,
      },
    ].concat(
      data.value?.categories.map(({ id, name }) => ({
        label: name,
        value: id.toString(),
      })) || [],
    ),
  )

  const shippingDelayOptions = computed(
    () =>
      data.value?.shippingDelays.map((value) => ({
        label: value.toString(),
        value: value.toString(),
      })) || [],
  )

  return {
    carrierOptions,
    categoryOptions,
    shippingDelayOptions,
  }
}
